import FullWidthLayout from '@shared/layouts/FullWidthLayout.vue';
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: FullWidthLayout,
      title: 'Login',
      isInternal: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/Logout.vue'),
    meta: {
      isInternal: true
    }
  },
  {
    path: '/:catchAll(.*)',
    name: 'error',
    component: () => import('@shared/components/Error/NotFoundError.vue'),
    meta: {
      title: 'Error',
      isInternal: true
    }
  },
  {
    path: '/playwright-test-login',
    name: 'playwrightTestLogin',
    component: () => import('@/views/TestLogin.vue'),
    meta: {
      layout: FullWidthLayout,
      title: 'Playwright Test Login',
      isInternal: true
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      // Redirect to login page if in production
      if (import.meta.env.VITE_ENV_NAME === 'PROD') {
        next({ name: 'login' });
      } else {
        next();
      }
    }
  },
  {
    path: '/component-module',
    redirect: '/component-module/button',
    name: 'ComponentModule',
    component: () => import('@/views/ComponentModule.vue'),
    meta: {
      title: 'Sealed component module',
      isInternal: true
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      // Redirect to job list page if in production
      if (import.meta.env.VITE_ENV_NAME === 'PROD') {
        next({ name: 'JobList' });
      } else {
        next();
      }
    },
    children: [
      {
        path: 'button',
        name: 'Button',
        component: () =>
          import('@component-module/components/Button/Button.examples.vue')
      },
      {
        path: 'icon-button',
        name: 'IconButton',
        component: () =>
          import(
            '@component-module/components/IconButton/IconButton.examples.vue'
          )
      },
      {
        path: 'pill-button-select',
        name: 'PillButtonSelect',
        component: () =>
          import(
            '@component-module/components/PillButtonSelect/PillButtonSelect.examples.vue'
          )
      },
      {
        path: 'filter-select-input',
        name: 'FilterSelectInput',
        component: () =>
          import(
            '@component-module/components/FilterSelectInput/FilterSelectInput.examples.vue'
          )
      },
      {
        path: 'filter-multi-select-input',
        name: 'FilterMultiSelectInput',
        component: () =>
          import(
            '@component-module/components/FilterMultiSelectInput/FilterMultiSelectInput.examples.vue'
          )
      },
      {
        path: 'filter-search-multi-select-input',
        name: 'FilterSearchMultiSelectInput',
        component: () =>
          import(
            '@component-module/components/FilterSearchMultiSelectInput/FilterSearchMultiSelectInput.examples.vue'
          )
      },
      {
        path: 'dropdown-menu',
        name: 'DropdownMenu',
        component: () =>
          import(
            '@component-module/components/DropdownMenu/DropdownMenu.examples.vue'
          )
      },
      {
        path: 'pill',
        name: 'Pill',
        component: () =>
          import('@component-module/components/Pill/Pill.examples.vue')
      },
      {
        path: 'section-box',
        name: 'SectionBox',
        component: () =>
          import(
            '@component-module/components/SectionBox/SectionBox.examples.vue'
          )
      },
      {
        path: 'label',
        name: 'Label',
        component: () =>
          import('@component-module/components/Label/Label.examples.vue')
      },
      {
        path: 'input-wrapper',
        name: 'InputWrapper',
        component: () =>
          import(
            '@component-module/components/InputWrapper/InputWrapper.examples.vue'
          )
      },
      {
        path: 'base-input',
        name: 'BaseInput',
        component: () =>
          import(
            '@component-module/components/BaseInput/BaseInput.examples.vue'
          )
      },
      {
        path: 'number-input',
        name: 'NumberInput',
        component: () =>
          import(
            '@component-module/components/NumberInput/NumberInput.examples.vue'
          )
      },
      {
        path: 'single-checkbox-input',
        name: 'SingleCheckboxInput',
        component: () =>
          import(
            '@component-module/components/SingleCheckboxInput/SingleCheckboxInput.examples.vue'
          )
      },
      {
        path: 'percentage-split-input',
        name: 'PercentageSplitInput',
        component: () =>
          import(
            '@component-module/components/PercentageSplitInput/PercentageSplitInput.examples.vue'
          )
      },
      {
        path: 'pill-button',
        name: 'PillButton',
        component: () =>
          import(
            '@component-module/components/PillButton/PillButton.examples.vue'
          )
      },
      {
        path: 'radio-button-input',
        name: 'RadioButtonInput',
        component: () =>
          import(
            '@component-module/components/RadioButtonInput/RadioButtonInput.examples.vue'
          )
      },
      {
        path: 'tabs',
        name: 'Tabs',
        component: () =>
          import('@component-module/components/Tabs/Tabs.examples.vue')
      },
      {
        path: 'modal',
        name: 'Modal',
        component: () =>
          import('@component-module/components/Modal/Modal.examples.vue')
      }
    ]
  }
];

export default routes;
